import styled from 'styled-components';
import { FlexRow } from '../../../../shared/FlexRow';
import React from 'react';

interface Props {
  step: number;
}

export const OnboardingProgress: React.FC<Props> = ({ step }) => {
  return (
    <ProgressBarWrapper>
      <CharacterWrapper>
        <FlexRow style={{ transform: 'translateY(-0.8rem)' }}>
          <TooltipBubble>{step === 1 ? '다음 1단계만 남았어요!' : '마지막 단계예요!'}</TooltipBubble>
          <TooltipBubbleArrow />
        </FlexRow>
        <Character src={'/images/workspace-wizard/create_progress_character.png'} alt={'character'} />
      </CharacterWrapper>
      <ProgressBar>
        <ProgressFill $step={step} />
        {step === 2 && <ProgressFillRight />}
      </ProgressBar>
    </ProgressBarWrapper>
  );
};

const ProgressBarWrapper = styled.div`
  width: 100%;
  height: 6.8rem;
  min-height: 6.8rem;
  margin-top: 1.6rem;
  position: relative;

  display: flex;
  align-items: flex-end;
`;

const CharacterWrapper = styled.div`
  position: absolute;
  top: 0.81rem;
  right: 0;
  z-index: 2;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 0.6rem;
`;

const Character = styled.img`
  width: 6rem;
  height: 5.5636rem;
`;

const TooltipBubble = styled.div`
  width: fit-content;
  padding: 0.6rem 0.8rem;
  border-radius: 4px;
  background-color: #1b1d1fe5;

  color: white;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 160%;
`;

const TooltipBubbleArrow = styled.div`
  width: 0;
  height: 0;
  border-top: 0.9rem solid transparent;
  border-bottom: 0.9rem solid transparent;
  border-left: 0.9rem solid #1b1d1fe5;
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 1.2rem;
  background-color: var(--background-3);
  border-radius: 100rem;
  position: relative;
  overflow: hidden;
`;

const ProgressFill = styled.div<{ $step: number }>`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 50%;
  background-color: ${props => (props.$step === 1 ? '#AFCAFF' : '#3a6cff')};
  border-radius: 100rem;
  z-index: 3;
`;

const ProgressFillRight = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 55%;
  background-color: #afcaff;
  border-radius: 0 100rem 100rem 0;
`;
